<rt-scrollable class="dialog-scroll-container">
  <div class="dialog-scroll-content">
    <div
      class="dialog-backdrop"
      (click)="!dialogConfig.disableClose && !dialogConfig.disableCloseOnBackdrop ? close() : null"
    ></div>
    @if (dialogConfig.backdropStyle === 'cover' && dialogCloseVisible) {
      <ng-template [ngTemplateOutlet]="dialogClose"></ng-template>
    }
    <rt-focus-trap>
      <div
        class="dialog-container"
        [class.vertically-centered]="dialogConfig?.containerOptions?.verticallyCentered"
      >
        <div
          [style.width]="dialogConfig.width"
          [style.maxWidth]="dialogConfig.maxWidth"
          class="dialog-content"
        >
          <ng-template portalHost></ng-template>
          @if (dialogConfig.backdropStyle === 'default' && dialogCloseVisible) {
            <ng-template [ngTemplateOutlet]="dialogClose"></ng-template>
          }
        </div>
      </div>
    </rt-focus-trap>
  </div>
</rt-scrollable>

<ng-template #dialogClose>
  <div class="dialog-close dialog-backdrop-style-{{ dialogConfig.backdropStyle }}">
    <rt-dialog-close [closeTooltip]="dialogConfig.closeTooltip" (click)="close()"></rt-dialog-close>
  </div>
</ng-template>
